export default __webpack_public_path__ + "static/media/unclear-icon.ad5a8a3a.svg";